import clsx from 'clsx';

import Button from '@ui/components/Button';
import IconArrow from '@ui/components/icons/IconArrow';

interface MonthNavigationButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
  disabled?: boolean;
}

const MonthNavigationButton = ({
  direction,
  onClick,
  disabled,
}: MonthNavigationButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      addonBefore={
        <IconArrow
          className={clsx(
            disabled ? 'fill-brand-gray-300' : 'fill-brand-gray-100',
          )}
          type={direction === 'prev' ? 'up' : 'down'}
          disabled={disabled}
        />
      }
    />
  );
};

export default MonthNavigationButton;
